import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403 && environment.ENV_ACTIVE_PROFILE === environment.ON_CUSTOMIDP) {
        handleUnauthorizedAccess();
      }
      return throwError(() => error);
    })
  );
};

function handleUnauthorizedAccess(): void {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = environment.ON_CUSTOMIDP_Auth.LoginUrl;
}
